import { BaseLookupModel, PaginationFilterRequest } from "./core.model";
import { ExtensionTypeEnum } from "./storage.model";

export interface RunningClubMedia {
    id: number;
    link: string;
    runningClubId: number;
    extensionType: ExtensionTypeEnum;
    runningClub: BaseLookupModel;
}

export interface UpsertRunningClubMedia {
    id?: number;
    link?: string;
    runningClubId?: number;
    extensionType?: ExtensionTypeEnum;
}

export class RunningClubMediaPaginationFilterRequest extends PaginationFilterRequest{  
    runningClubId?: number;
}

